import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import { refreshButtonTheme } from './refreshButtonStyles';
import { visuallyHidden } from '@mui/utils';
import { onEnterKeyPress } from '../../../utils/wcagUtils';
export var RefreshButton = function RefreshButton(props) {
  var ariaLiveLabel = props.ariaLiveLabel,
    loading = props.loading,
    onClick = props.onClick;
  var _useState = useState(void 0),
    _useState2 = _slicedToArray(_useState, 2),
    ariaLiveContent = _useState2[0],
    setAriaLiveContent = _useState2[1];
  var refreshClicked = useRef(false);
  useEffect(function () {
    if (refreshClicked.current && !loading) {
      setAriaLiveContent(ariaLiveLabel);
    } else {
      setAriaLiveContent('');
    }
  }, [loading]);
  var handleRefresh = function handleRefresh(e) {
    refreshClicked.current = true;
    onClick === null || onClick === void 0 || onClick(e);
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: refreshButtonTheme
  }, /*#__PURE__*/React.createElement(Button, _extends({
    disableRipple: true,
    className: "EmbersRefreshButton-root",
    onClick: handleRefresh,
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, handleRefresh);
    }
  }, props), /*#__PURE__*/React.createElement("i", {
    role: "none",
    className: "icon-reload"
  })), /*#__PURE__*/React.createElement("div", {
    className: "Embers-sr-only",
    style: visuallyHidden,
    "aria-relevant": "all",
    role: "status",
    "aria-live": "polite"
  }, ariaLiveContent));
};